import React from 'react';

import {contactListColumnIds} from '../../../../../util/uiconstants';

import TagsDropdownColumn from '../../TagsDropdownColumn';

const TagsColumn = ({item}) => <TagsDropdownColumn list={item.tags} />;

export const config = (labels) => ({
	id: contactListColumnIds.tags,
	label: labels.columnTags,
	propName: 'tags',
	width: 'var(--px-200)',
	sortBy: [{propName: 'tags', sortByLength: true}, 'name', 'lastName'],
	customCell: (item) => {
		const props = {item};
		return <TagsColumn {...props} />;
	}
});
